module.exports = __webpack_public_path__ + "img/student_35.3f76e0d0.png";